(function () {
  'use strict';

  const Bundle = () => {
      // eslint-disable-next-line no-undef
      const { createApp } = Vue;
      createApp({
        data() {
          return {
            mounted: false,
            type: 'standard',
            // Make sure bundleData is properly defined and accessible
            bundleData: window.bundleData || {}, // Access from window object and provide fallback
            bundleContents: [],
            bundleTotal: 0,
            bundleSubTotal: 0,
            discountAmount: 0,
            hasDiscount: false,
            reviewOrder: false,
            itemCount: 0,
            // NEW reactive properties:
            activeStep: 0, // used for the bottom tabs/steps
            activeSelections: {
              'Placemat': [],
              'Plate': [],
              'Napkin': [],
              'Bowl': [],
              'Cutlery': [],
              'Glassware': [],
              'Servingware': []

            },
            visualiser: {
              place1: {
                placemat_image: null,
                placemat_id: null,
                plate_image: null,
                plate_id: null,
                napkin_image: null,
                napkin_id: null,
                cutlery_image: null,
                cutlery_id: null,
                glassware_image: null,
                glassware_id: null,
                bowl_image: null,
                bowl_id: null
              },
              place2: {
                placemat_image: null,
                placemat_id: null,
                plate_image: null,
                plate_id: null,
                napkin_image: null,
                napkin_id: null,
                cutlery_image: null,
                cutlery_id: null,
                glassware_image: null,
                glassware_id: null,
                bowl_image: null,
                bowl_id: null
              },
              place3: {
                placemat_image: null,
                placemat_id: null,
                plate_image: null,
                plate_id: null,
                napkin_image: null,
                napkin_id: null,
                cutlery_image: null,
                cutlery_id: null,
                glassware_image: null,
                glassware_id: null,
                bowl_image: null,
                bowl_id: null
              },
              place4: {
                placemat_image: null,
                placemat_id: null,
                plate_image: null,
                plate_id: null,
                napkin_image: null,
                napkin_id: null,
                cutlery_image: null,
                cutlery_id: null,
                glassware_image: null,
                glassware_id: null,
                bowl_image: null,
                bowl_id: null
              },
              servingware: {
                slot_1_image: null,
                slot_1_id: null,
                slot_2_image: null,
                slot_2_id: null,
                slot_3_image: null,
                slot_3_id: null
              }
            }
          }
        },
        computed: {
          // Individual element properties
          // Place 1 elements
          place1Placemat() {
            return this.visualiser.place1.placemat_image !== null;
          },
          place1Plate() {
            return this.visualiser.place1.plate_image !== null;
          },
          place1Napkin() {
            return this.visualiser.place1.napkin_image !== null;
          },
          place1Cutlery() {
            return this.visualiser.place1.cutlery_image !== null;
          },
          place1Bowl() {
            return this.visualiser.place1.bowl_image !== null;
          },
          place1Glassware() {
            return this.visualiser.place1.glassware_image !== null;
          },
          
          // Place 2 elements
          place2Placemat() {
            return this.visualiser.place2.placemat_image !== null;
          },
          place2Plate() {
            return this.visualiser.place2.plate_image !== null;
          },
          place2Napkin() {
            return this.visualiser.place2.napkin_image !== null;
          },
          place2Cutlery() {
            return this.visualiser.place2.cutlery_image !== null;
          },
          place2Bowl() {
            return this.visualiser.place2.bowl_image !== null;
          },
          place2Glassware() {
            return this.visualiser.place2.glassware_image !== null;
          },
          
          // Place 3 elements
          place3Placemat() {
            return this.visualiser.place3.placemat_image !== null;
          },
          place3Plate() {
            return this.visualiser.place3.plate_image !== null;
          },
          place3Napkin() {
            return this.visualiser.place3.napkin_image !== null;
          },
          place3Cutlery() {
            return this.visualiser.place3.cutlery_image !== null;
          },
          place3Bowl() {
            return this.visualiser.place3.bowl_image !== null;
          },
          place3Glassware() {
            return this.visualiser.place3.glassware_image !== null;
          },

          // Place 4 elements
          place4Placemat() {
            return this.visualiser.place4.placemat_image !== null;
          },
          place4Plate() {
            return this.visualiser.place4.plate_image !== null;
          },
          place4Napkin() {
            return this.visualiser.place4.napkin_image !== null;
          },
          place4Cutlery() {
            return this.visualiser.place4.cutlery_image !== null;
          },
          place4Bowl() {
            return this.visualiser.place4.bowl_image !== null;
          },
          place4Glassware() {
            return this.visualiser.place4.glassware_image !== null;
          },
          
          slot1() {
            return this.visualiser.servingware.slot_1_image !== null;
          },
          slot2() {
            return this.visualiser.servingware.slot_2_image !== null;
          },
          slot3() {
            return this.visualiser.servingware.slot_3_image !== null;
          },
          
          // Overall place setting visibility
          place1Active() {
            const place = this.visualiser.place1;
            return place.placemat_image !== null || place.plate_image !== null || 
                   place.napkin_image !== null || place.cutlery_image !== null || place.bowl_image !== null || place.glassware_image !== null ;
          },
          place2Active() {
            const place = this.visualiser.place2;
            return place.placemat_image !== null || place.plate_image !== null || 
                   place.napkin_image !== null || place.cutlery_image !== null || place.bowl_image !== null || place.glassware_image !== null;
          },
          place3Active() {
            const place = this.visualiser.place3;
            return place.placemat_image !== null || place.plate_image !== null || 
                   place.napkin_image !== null || place.cutlery_image !== null || place.bowl_image !== null || place.glassware_image !== null;
          },
          place4Active() {
            const place = this.visualiser.place4;
            return place.placemat_image !== null || place.plate_image !== null || 
                   place.napkin_image !== null || place.cutlery_image !== null || place.bowl_image !== null || place.glassware_image !== null ;
          }
        },
        methods: {
          // existing methods ...
          currency(price) {
            return `$${(price / 100).toFixed(2)}`
          },
   
          isStepComplete(stepIndex) {
            const step = this.bundleData.steps[stepIndex];
            if (!step || !step.collections) return false;
            
            // Get the item type for this step's collections
            const itemType = step.collections[0].item_type;
            
            // Different completion criteria based on item type
            if (itemType === 'Servingware') {
              // For servingware, check if all 3 slots are filled
              return this.visualiser.servingware.slot_1_image !== null &&
                     this.visualiser.servingware.slot_2_image !== null &&
                     this.visualiser.servingware.slot_3_image !== null;
            } else {
              // For place setting items (plates, cutlery, etc)
              // Check all 4 place settings based on item type
              const imageProperty = {
                'Placemat': 'placemat',
                'Plate': 'plate',
                'Napkin': 'napkin',
                'Bowl': 'bowl',
                'Cutlery': 'cutlery',
                'Glassware': 'glassware'
              }[itemType];
              
              if (!imageProperty) return false;
              
              // Check if all 4 places have this item type
              return this.visualiser.place1[`${imageProperty}_image`] !== null &&
                     this.visualiser.place2[`${imageProperty}_image`] !== null &&
                     this.visualiser.place3[`${imageProperty}_image`] !== null &&
                     this.visualiser.place4[`${imageProperty}_image`] !== null;
            }
          },

          renderDescription(inputString){
              // Replace "&amp;" with "&"
              const replacedAmp = inputString.replace(/&amp;/g, "&");
              
              // Replace "&nbsp;" with a line break <br>
              const replacedNbsp = replacedAmp.replace(/&nbsp;/g, "<br>");
              
              return replacedNbsp.replace(/<br>/g, "<br />");
          },

          handleProductClick(id, itemType, setSize, event, inventoryQuantity) {
              let item = this.findProductById(id);
              let targetElement = event ? event.currentTarget : null;
              let visualRepresentation = item.visual_rep || item.image;
              
              // Check inventory quantity - if not provided or invalid, assume unlimited
              inventoryQuantity = typeof inventoryQuantity === 'number' && inventoryQuantity >= 0 ? inventoryQuantity : Infinity;
              
              // Get current usage of this item in the bundle
              const currentUsage = this.countProductInBundle(id);
              
              // If inventory is zero, don't proceed
              if (inventoryQuantity === 0) {
                console.log('Item out of stock:', id);
                // Optionally notify the user that item is out of stock
                return;
              }

              // For all item types, check if adding one more would exceed inventory
              // Note: Sets of 4 are treated as a single inventory unit
              if (currentUsage >= inventoryQuantity) {
                console.log('Maximum available inventory reached for item:', id);
                return;
              }

              if (itemType === 'Servingware') {
                // Find which slot we're filling
                let slotToFill = null;
                let replacedItemId = null;
                
                if (this.visualiser.servingware.slot_1_image === null) {
                  slotToFill = 1;
                } else if (this.visualiser.servingware.slot_2_image === null) {
                  slotToFill = 2;
                } else if (this.visualiser.servingware.slot_3_image === null) {
                  slotToFill = 3;
                } else {
                  // All slots filled, replace the THIRD one (last one) for clarity
                  slotToFill = 3;
                  replacedItemId = this.visualiser.servingware.slot_3_id;
                }
                
                // If we're replacing an item, remove it from the bundle first
                if (replacedItemId) {
                  this.removeLineItem(replacedItemId);
                  
                  // Also remove from activeSelections
                  const replaceIndex = this.activeSelections[itemType].indexOf(replacedItemId);
                  if (replaceIndex !== -1) {
                    this.activeSelections[itemType].splice(replaceIndex, 1);
                    this.removeActiveClassById(replacedItemId, this.activeStep);
                  }
                  
                  // Find and remove indicator from replaced item - just the specific slot indicator
                  const replacedElement = document.querySelector(`.bundle-builder__product-card-image[data-product-id="${replacedItemId}"]`);
                  if (replacedElement) {
                    this.removeIndicator(replacedElement, slotToFill);
                    // Only remove active class if no indicators remain
                    if (!replacedElement.querySelector('.bundle-builder__position-indicator')) {
                      replacedElement.classList.remove('active');
                    }
                  }
                }
                
                // Update the visualizer with both image and ID
                this.visualiser.servingware[`slot_${slotToFill}_image`] = visualRepresentation;
                this.visualiser.servingware[`slot_${slotToFill}_id`] = id;
                
                // Add to activeSelections
                if (!this.activeSelections[itemType].includes(id)) {
                  this.activeSelections[itemType].push(id);
                }
                
                // Add class to this element
                if (targetElement) {
                  targetElement.classList.add('active');
                  // Add slot number indicator overlay (without the 'S' prefix)
                  this.addPlaceNumberIndicator(targetElement, slotToFill);
                }
                
                // Add item to the bundle contents
                this.add(id);
              } else {
                // Determine which image property to update based on itemType
                const imageProperty = {
                    'Placemat': 'placemat',
                    'Plate': 'plate',
                    'Napkin': 'napkin',
                    'Bowl': 'bowl',
                    'Cutlery': 'cutlery',
                    'Glassware': 'glassware'
                }[itemType];

                if (imageProperty) {
                    // If setSize is 4, fill all place settings with this item
                    if (setSize === 4) {
                        // For sets of 4, we treat it as one inventory unit 
                        // (inventory check was already done at the top)
                        // Find any products of this type that need to be removed
                        for (let i = 1; i <= 4; i++) {
                            const place = `place${i}`;
                            const replacedId = this.visualiser[place][`${imageProperty}_id`];
                            
                            if (replacedId && replacedId !== id) {
                                this.removeLineItem(replacedId);
                                
                                // Find and remove indicator from replaced item
                                const replacedElement = document.querySelector(`.bundle-builder__product-card-image[data-product-id="${replacedId}"]`);
                                if (replacedElement) {
                                  replacedElement.classList.remove('active');
                                  this.removeAllIndicators(replacedElement);
                                }
                            }
                        }

                        if (item.visual_rep_urls !== null) {
                          let visual_rep_urls = item.visual_rep_urls.split(',');
                          // Fill all places with both image and ID
                          for (let i = 1; i <= 4; i++) {
                            const place = `place${i}`;
                            this.visualiser[place][`${imageProperty}_image`] = visual_rep_urls[i-1];
                            this.visualiser[place][`${imageProperty}_id`] = id;
                          }
                        } else {
                          // Fill all places with both image and ID
                          for (let i = 1; i <= 4; i++) {
                            const place = `place${i}`;
                            this.visualiser[place][`${imageProperty}_image`] = visualRepresentation;
                            this.visualiser[place][`${imageProperty}_id`] = id;
                          }
                        }
                        
                        // Clear existing active classes for this type
                        this.clearActiveClassesForType(itemType);
                        
                     
                        
                        // Track this as the only active selection for this type
                        this.activeSelections[itemType] = [id];
                        
                        // Add active class to this element
                        if (targetElement) {
                          targetElement.classList.add('active');
                          // Add checkmark for full set
                          this.addCheckmarkIndicator(targetElement);
                        }
                        
                        // Add item to bundle - for set of 4, we add one item with quantity 4
                        this.add(id);
                    } else if (setSize === 1) {
                        // Check if there's currently a set of 4 in this place
                        let hasSetOfFour = false;
                        let setOfFourId = null;
                        
                        // Check the first place to see if the same ID is in all 4 places
                        const firstPlaceId = this.visualiser.place1[`${imageProperty}_id`];
                        if (firstPlaceId) {
                            const product = this.findProductById(firstPlaceId);
                            if (product && product.set_size === 4) {
                                // Check if all places have this same ID
                                let allMatch = true;
                                for (let i = 2; i <= 4; i++) {
                                    if (this.visualiser[`place${i}`][`${imageProperty}_id`] !== firstPlaceId) {
                                        allMatch = false;
                                        break;
                                    }
                                }
                                if (allMatch) {
                                    hasSetOfFour = true;
                                    setOfFourId = firstPlaceId;
                                }
                            }
                        }
                        
                        // If there is a set of 4, remove it completely
                        if (hasSetOfFour && setOfFourId) {
                            // Remove the set of 4 from the bundle
                            this.removeLineItem(setOfFourId);
                            
                            // Remove all indicators and active class from the set of 4 product
                            const setOfFourElement = document.querySelector(`.bundle-builder__product-card-image[data-product-id="${setOfFourId}"]`);
                            if (setOfFourElement) {
                                setOfFourElement.classList.remove('active');
                                this.removeAllIndicators(setOfFourElement);
                            }
                            
                            // Clear all places in the visualizer
                            for (let i = 1; i <= 4; i++) {
                                const place = `place${i}`;
                                this.visualiser[place][`${imageProperty}_image`] = null;
                                this.visualiser[place][`${imageProperty}_id`] = null;
                            }
                            
                            // Clear this item type from active selections
                            this.activeSelections[itemType] = [];
                            
                            // Now place the new single item in slot 1
                            this.visualiser.place1[`${imageProperty}_image`] = visualRepresentation;
                            this.visualiser.place1[`${imageProperty}_id`] = id;
                            
                            // Add to active selections
                            this.activeSelections[itemType].push(id);
                            
                            // Add to bundle
                            this.add(id);
                            
                            // Add active class and place indicator to the new element
                            if (targetElement) {
                                targetElement.classList.add('active');
                                this.addPlaceNumberIndicator(targetElement, 1);
                            }
                            
                            return; // Exit early as we've handled this special case
                        }
                        
                        // For individual items, ALWAYS find the first empty place
                        let placeFilled = null;
                        let allPlacesFilled = true;
                        
                        // First check if there are ANY empty slots from 1 to 4
                        for (let i = 1; i <= 4; i++) {
                            const place = `place${i}`;
                            if (this.visualiser[place][`${imageProperty}_image`] === null) {
                                // Found an empty slot, fill it
                                placeFilled = i;
                                allPlacesFilled = false;
                                
                                this.visualiser[place][`${imageProperty}_image`] = visualRepresentation;
                                this.visualiser[place][`${imageProperty}_id`] = id;
                                
                                // Track this selection
                                this.activeSelections[itemType].push(id);
                                
                                // Add item to the bundle
                                this.add(id);
                                break;
                            }
                        }
                        
                        // Only if all places are truly filled, replace the 4th one
                        if (allPlacesFilled) {
                            const place = 'place4';
                            placeFilled = 4;
                            
                            // Get the ID of the item being replaced
                            const oldestId = this.visualiser[place][`${imageProperty}_id`];
                            
                            // Remove from bundle if it exists
                            if (oldestId) {
                                const oldItemInBundle = this.bundleContents.find(x => x.id === oldestId);
                                if (oldItemInBundle && oldItemInBundle.quantity === 1) {
                                    this.removeLineItem(oldestId);
                                } else if (oldItemInBundle) {
                                    oldItemInBundle.quantity--;
                                }
                                
                                // Remove indicator for ONLY place 4 from replaced item
                                const replacedElement = document.querySelector(`.bundle-builder__product-card-image[data-product-id="${oldestId}"]`);
                                if (replacedElement) {
                                    this.removeIndicator(replacedElement, placeFilled);
                                    // Only remove active class if no indicators remain
                                    if (!replacedElement.querySelector('.bundle-builder__position-indicator')) {
                                        replacedElement.classList.remove('active');
                                    }
                                }
                                
                                // Remove from activeSelections - only if this was the last occurrence
                                const countInPlaces = this.countProductInPlaces(oldestId, itemType);
                                if (countInPlaces <= 1) {
                                    const oldIndex = this.activeSelections[itemType].indexOf(oldestId);
                                    if (oldIndex !== -1) {
                                        this.activeSelections[itemType].splice(oldIndex, 1);
                                    }
                                }
                            }
                            
                            // Update visualizer with both image and ID
                            this.visualiser[place][`${imageProperty}_image`] = visualRepresentation;
                            this.visualiser[place][`${imageProperty}_id`] = id;
                            
                            // Add new selection
                            this.activeSelections[itemType].push(id);
                            
                            // Add item to the bundle
                            this.add(id);
                        }
                        
                        // Add active class to this element regardless
                        if (targetElement) {
                          targetElement.classList.add('active');
                          // Add place number indicator
                          if (placeFilled) {
                            this.addPlaceNumberIndicator(targetElement, placeFilled);
                          }
                        }
                    } else {
                        // Other set sizes
                        // First check if there are ANY empty slots from 1 to 4
                        let placeFilled = null;
                        let allPlacesFilled = true;
                        
                        // First check if there are ANY empty slots from 1 to 4
                        for (let i = 1; i <= 4; i++) {
                            const place = `place${i}`;
                            if (this.visualiser[place][`${imageProperty}_image`] === null) {
                                // Found an empty slot, fill it
                                placeFilled = i;
                                allPlacesFilled = false;
                                
                                this.visualiser[place][`${imageProperty}_image`] = visualRepresentation;
                                this.visualiser[place][`${imageProperty}_id`] = id;
                                
                                // Track this selection
                                this.activeSelections[itemType].push(id);
                                
                                // Add item to the bundle
                                this.add(id);
                                break;
                            }
                        }
                        
                        // Only if all places are truly filled, replace the 4th one
                        if (allPlacesFilled) {
                            const place = 'place4';
                            placeFilled = 4;
                            
                            // Get the ID of the item being replaced
                            const oldestId = this.visualiser[place][`${imageProperty}_id`];
                            
                            // Remove from bundle if it exists
                            if (oldestId) {
                                this.removeLineItem(oldestId);
                                
                                // Remove indicator ONLY for place 4 from replaced item
                                const replacedElement = document.querySelector(`.bundle-builder__product-card-image[data-product-id="${oldestId}"]`);
                                if (replacedElement) {
                                    this.removeIndicator(replacedElement, placeFilled);
                                    // Only remove active class if no indicators remain
                                    if (!replacedElement.querySelector('.bundle-builder__position-indicator')) {
                                        replacedElement.classList.remove('active');
                                    }
                                }
                                
                                // Remove from activeSelections - only if this was the last occurrence
                                const countInPlaces = this.countProductInPlaces(oldestId, itemType);
                                if (countInPlaces <= 1) {
                                    const oldIndex = this.activeSelections[itemType].indexOf(oldestId);
                                    if (oldIndex !== -1) {
                                        this.activeSelections[itemType].splice(oldIndex, 1);
                                    }
                                }
                            }
                            
                            // Update visualizer with both image and ID
                            this.visualiser[place][`${imageProperty}_image`] = visualRepresentation;
                            this.visualiser[place][`${imageProperty}_id`] = id;
                            
                            // Add new selection
                            this.activeSelections[itemType].push(id);
                            
                            // Add item to the bundle
                            this.add(id);
                        }
                        
                        // Add active class to this element
                        if (targetElement) {
                          targetElement.classList.add('active');
                          // Add place number indicator
                          if (placeFilled) {
                            this.addPlaceNumberIndicator(targetElement, placeFilled);
                          }
                        }
                    }
                }
              }
          },

          add(id) {
            let product = this.findProductById(id);
            if (!product) return;
            
            // Get set size
            const setSize = product.set_size || 1;
            
            // For set_size = 4 items, we only add one to the bundle (full set)
            if (setSize === 4) {
              // Check if this full set is already in the bundle
              const existingItem = this.bundleContents.find(item => item.id === product.variant_id);
              if (existingItem) {
                return; // Already have this full set in the bundle
              }
            }
            
            // Check existing quantity of this specific item in the bundle
            const existingItem = this.bundleContents.find(item => item.id === product.variant_id);
            
            // Check if this specific item already exists in the bundle
            if (existingItem) {
              // If it's an individual item (setSize=1), increment quantity 
              if (setSize === 1) {
                existingItem.quantity++;
              }
              // For setSize=4, we've already checked above and returned if it exists
            } else {
              // Add as new item with quantity 1
              this.bundleContents.push({
                id: product.variant_id,
                variant_title: product.variant_title,
                title: product.title,
                thumbnail: product.image,
                quantity: 1,
                price: product.price,
                set_size: product.set_size
              });
            }
            
            this.update();
          },

          findProductById(id) {
            // search through bundleData.steps collections to find a matching product variant_id
            for (let step of this.bundleData.steps) {
              for (let collection of step.collections) {
                for (let prod of collection.products) {
                  if (prod.variant_id === id) return prod
                }
              }
            }
            return null
          },

          productExistsInBundle(id) {
            return this.bundleContents.some(x => x.id === id)
          },

          update() {
            let price = 0;
            let count = 0;
            this.bundleContents.forEach(item => {
              price += (item.price * item.quantity);
              count += item.quantity;
            });

            this.bundleSubTotal = price;

            // Apply 20% discount if there are more than 3 products in the bundle
            if (this.itemCount > 3) {
              this.discountPercentage = this.bundleData.discount_percentage;
              this.discountDecimal = this.discountPercentage / 100;
              this.discountAmount = Math.round(price * this.discountDecimal); // 20% discount, rounded to whole number
              this.bundleTotal = price - this.discountAmount;
              this.hasDiscount = true;
            } else {
              this.discountAmount = 0;
              this.bundleTotal = price;
              this.hasDiscount = false;
            }

            this.itemCount = count;
          },

          updateLineItem(id, number, event) {
            let item = this.bundleContents.find(x => x.id === id);
            item.quantity += number;
            event.target.parentNode.querySelector('p').innerHTML = item.quantity;
            if (item.quantity === 0) {
              this.removeLineItem(id);
              event.target.parentNode.querySelector('p').innerHTML = 1;
            }
            this.update();
          },

          removeLineItem(id) {
            let index = this.bundleContents.findIndex(x => x.id === id);
            if (index > -1) {
              this.bundleContents.splice(index, 1);
            }
            this.update();
          },

          addToCart(e) {
            let items = [];
            let randoNumber = Math.floor(1000 + Math.random() * 9000);

            e.target.innerHTML = "Loading...";

            this.bundleContents.forEach(item => {
              let id = item.id;
              let properties = { bundle_id: randoNumber };

              items.push({ 
                'id': id, 
                'quantity': item.quantity, 
                properties 
              });
            });

            let formData = { 
              'items': items 
            };

            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(formData)
            })
              .then(response => {
                console.log(response.json());
                window.location.href = "/cart";
              })
              .catch(error => {
                console.error('Error:', error);
              }); 
          },

          clearActiveSelections(itemType) {
              const currentStepSelector = `.bundle-builder__tab-content[data-step="${this.activeStep}"]`;
              const currentStep = document.querySelector(currentStepSelector);
              
              if (currentStep) {
                  // Find all active elements of this type in the current step and remove the active class
                  const selector = `.bundle-builder__product-card[data-product-type="${itemType}"] .bundle-builder__product-card-image.active`;
                  const activeElements = currentStep.querySelectorAll(selector);
                  activeElements.forEach(element => {
                      element.classList.remove('active');
                      // Also remove any indicators
                      this.removeIndicators(element);
                  });
              }
              
              // Clear the tracking array for this type in the current step
              this.activeSelections[itemType] = [];
          },
          
          removeActiveClassById(id, stepIndex) {
              const currentStepSelector = `.bundle-builder__tab-content[data-step="${stepIndex}"]`;
              const currentStep = document.querySelector(currentStepSelector);
              
              if (currentStep) {
                  const selector = `.bundle-builder__product-card-image[data-product-id="${id}"]`;
                  const element = currentStep.querySelector(selector);
                  if (element) {
                      element.classList.remove('active');
                      // Also remove any indicators
                      this.removeIndicators(element);
                  }
              } else {
                  // Fallback to global search if step container not found
                  const selector = `.bundle-builder__product-card-image[data-product-id="${id}"]`;
                  const element = document.querySelector(selector);
                  if (element) {
                      element.classList.remove('active');
                      // Also remove any indicators
                      this.removeIndicators(element);
                  }
              }
          },

          productDeselected(id, itemType, event) {
              // Find the product's details
              let item = this.findProductById(id);
              let targetElement = event ? event.currentTarget : null;
              let placeRemoved = null;
              
              // Find which place this specific item is being removed from
              placeRemoved = this.findItemPlacement(id, itemType);
              
              // Remove only that specific indicator, not all indicators
              if (targetElement && placeRemoved) {
                  this.removeIndicator(targetElement, placeRemoved);
              }
              
              // If no indicators remain, remove active class completely
              if (targetElement && !targetElement.querySelector('.bundle-builder__position-indicator')) {
                  targetElement.classList.remove('active');
              }
              
              // For servingware
              if (itemType === 'Servingware') {
                  // Determine which slot has this item and clear it
                  if (this.visualiser.servingware.slot_1_id === id) {
                      this.visualiser.servingware.slot_1_image = null;
                      this.visualiser.servingware.slot_1_id = null;
                  } else if (this.visualiser.servingware.slot_2_id === id) {
                      this.visualiser.servingware.slot_2_image = null;
                      this.visualiser.servingware.slot_2_id = null;
                  } else if (this.visualiser.servingware.slot_3_id === id) {
                      this.visualiser.servingware.slot_3_image = null;
                      this.visualiser.servingware.slot_3_id = null;
                  }
                  
                  // Remove from active selections
                  const index = this.activeSelections[itemType].indexOf(id);
                  if (index !== -1) {
                      this.activeSelections[itemType].splice(index, 1);
                  }
                  
                  // Remove from the bundle
                  this.removeLineItem(id);
              } else {
                  // For other product types
                  const imageProperty = {
                      'Placemat': 'placemat',
                      'Plate': 'plate',
                      'Napkin': 'napkin',
                      'Bowl': 'bowl',
                      'Cutlery': 'cutlery',
                      'Glassware': 'glassware'
                  }[itemType];
                  
                  if (imageProperty) {
                      // Check if this is a set of 4
                      const isFullSet = item.set_size === 4;
                      
                      if (isFullSet) {
                          // Clear all places of this type
                          for (let i = 1; i <= 4; i++) {
                              const place = `place${i}`;
                              if (this.visualiser[place][`${imageProperty}_id`] === id) {
                                  this.visualiser[place][`${imageProperty}_image`] = null;
                                  this.visualiser[place][`${imageProperty}_id`] = null;
                              }
                          }
                          
                          // Remove from active selections
                          this.activeSelections[itemType] = this.activeSelections[itemType].filter(activeId => activeId !== id);
                          
                          // Remove from the bundle
                          this.removeLineItem(id);
                      } else {
                          // Find which place has this item
                          let placeFound = false;
                          for (let i = 1; i <= 4; i++) {
                              const place = `place${i}`;
                              if (this.visualiser[place][`${imageProperty}_id`] === id) {
                                  this.visualiser[place][`${imageProperty}_image`] = null;
                                  this.visualiser[place][`${imageProperty}_id`] = null;
                                  placeFound = true;
                                  break;
                              }
                          }
                          
                          if (placeFound) {
                              // Remove from active selections - but only one occurrence
                              const index = this.activeSelections[itemType].indexOf(id);
                              if (index !== -1) {
                                  this.activeSelections[itemType].splice(index, 1);
                              }
                              
                              // Remove from the bundle
                              this.removeLineItem(id);
                          }
                      }
                  }
              }
          },

          removeItemFromBundle(item) {
            // Find and remove the item from bundleContents
            const index = this.bundleContents.findIndex(bundleItem => 
              bundleItem.id === item.id);
            
            if (index !== -1) {
              // Get item details
              const product = this.findProductById(item.id);
              const itemType = this.getItemTypeById(item.id);
              const setSize = product.set_size || 1;
              
              // Find the specific place this item is being removed from
              let placeRemoved = null;
              
              // For servingware, we'll just remove the last one alphabetically (S3, then S2, then S1)
              if (itemType === 'Servingware') {
                for (let i = 3; i >= 1; i--) {
                  if (this.visualiser.servingware[`slot_${i}_id`] === item.id) {
                    placeRemoved = i; // Just use the number, not 'S'+i
                    this.visualiser.servingware[`slot_${i}_image`] = null;
                    this.visualiser.servingware[`slot_${i}_id`] = null;
                    break;
                  }
                }
              } else {
                // For other items, find which place it's in (removing from highest number first)
                const baseProperty = {
                  'Placemat': 'placemat',
                  'Plate': 'plate',
                  'Napkin': 'napkin',
                  'Bowl': 'bowl',
                  'Cutlery': 'cutlery',
                  'Glassware': 'glassware'
                }[itemType];
                
                if (setSize === 4) {
                  // For full sets, remove all
                  for (let i = 1; i <= 4; i++) {
                    const place = `place${i}`;
                    if (this.visualiser[place][`${baseProperty}_id`] === item.id) {
                      this.visualiser[place][`${baseProperty}_image`] = null;
                      this.visualiser[place][`${baseProperty}_id`] = null;
                    }
                  }
                } else {
                  // For individual items, just remove one place (highest number first)
                  for (let i = 4; i >= 1; i--) {
                    const place = `place${i}`;
                    if (this.visualiser[place][`${baseProperty}_id`] === item.id) {
                      placeRemoved = i;
                      this.visualiser[place][`${baseProperty}_image`] = null;
                      this.visualiser[place][`${baseProperty}_id`] = null;
                      break;
                    }
                  }
                }
              }
              
              // Find and update indicators for this item
              const selector = `.bundle-builder__product-card-image[data-product-id="${item.id}"]`;
              const elements = document.querySelectorAll(selector);
              
              if (setSize === 4) {
                // For full sets, remove active class and all indicators
                elements.forEach(element => {
                  element.classList.remove('active');
                  this.removeAllIndicators(element);
                });
                
                // Remove from active selections
                this.activeSelections[itemType] = this.activeSelections[itemType].filter(id => id !== item.id);
              } else {
                // For individual items, just remove one indicator
                if (placeRemoved !== null) {
                  elements.forEach(element => {
                    // Remove just this specific indicator
                    this.removeIndicator(element, placeRemoved);
                    
                    // If no indicators remain, remove active class too
                    if (!element.querySelector('.bundle-builder__position-indicator')) {
                      element.classList.remove('active');
                    }
                  });
                  
                  // Remove one occurrence from active selections
                  const activeIndex = this.activeSelections[itemType].indexOf(item.id);
                  if (activeIndex !== -1) {
                    this.activeSelections[itemType].splice(activeIndex, 1);
                  }
                }
              }
              
              // Remove from bundle contents
              if (this.bundleContents[index].quantity > 1 && setSize === 1) {
                // If it's an individual item and we have multiple, just decrement
                this.bundleContents[index].quantity--;
              } else {
                // Otherwise remove the whole item
                this.bundleContents.splice(index, 1);
              }
              
              // Update the totals after removing the item
              this.update();
            }
          },

          removeItemFromVisualiser(id, itemType, setSize) {
            // Determine which image property to update based on itemType
            const baseProperty = {
              'Placemat': 'placemat',
              'Plate': 'plate',
              'Napkin': 'napkin',
              'Cutlery': 'cutlery',
              'Bowl': 'bowl',
              'Glassware': 'glassware'
            }[itemType];
            
            if (itemType === 'Servingware') {
              // Check each servingware slot
              for (let i = 1; i <= 3; i++) {
                if (this.visualiser.servingware[`slot_${i}_id`] === id) {
                  this.visualiser.servingware[`slot_${i}_image`] = null;
                  this.visualiser.servingware[`slot_${i}_id`] = null;
                  break; // Only remove one for servingware
                }
              }
            } else if (baseProperty) {
              if (setSize === 4) {
                // If it's a full set, clear all place settings for this item type
                for (let i = 1; i <= 4; i++) {
                  const place = `place${i}`;
                  if (this.visualiser[place][`${baseProperty}_id`] === id) {
                    this.visualiser[place][`${baseProperty}_image`] = null;
                    this.visualiser[place][`${baseProperty}_id`] = null;
                  }
                }
              } else {
                // For individual items, only remove one occurrence
                for (let i = 1; i <= 4; i++) {
                  const place = `place${i}`;
                  if (this.visualiser[place][`${baseProperty}_id`] === id) {
                    this.visualiser[place][`${baseProperty}_image`] = null;
                    this.visualiser[place][`${baseProperty}_id`] = null;
                    break; // Only remove one occurrence
                  }
                }
              }
            }
          },

          getItemTypeById(id) {
            // Search through all steps and collections to find the product
            for (const step of this.bundleData.steps) {
              for (const collection of step.collections) {
                for (const product of collection.products) {
                  if (product.variant_id === id) {
                    return collection.item_type;
                  }
                }
              }
            }
            return null;
          },

          addPlaceNumberIndicator(element, placeNumber) {
              // Check if this specific indicator already exists
              const existingIndicator = element.querySelector(`.bundle-builder__position-indicator-${placeNumber}`);
              if (existingIndicator) return; // Skip if already exists
              
              // Create place number indicator
              const indicator = document.createElement('div');
              indicator.className = `bundle-builder__position-indicator bundle-builder__position-indicator-${placeNumber}`;
              indicator.textContent = placeNumber;
              
              // Add to element
              element.style.position = 'relative';
              element.appendChild(indicator);
          },

          addCheckmarkIndicator(element) {
              // Check if checkmark indicator already exists
              const existingIndicator = element.querySelector('.bundle-builder__position-indicator--checkmark');
              if (existingIndicator) return; // Skip if already exists
              
              // Create checkmark indicator
              const indicator = document.createElement('div');
              indicator.className = 'bundle-builder__position-indicator bundle-builder__position-indicator--checkmark bundle-builder__position-indicator-all';

              // Add checkmark SVG
              indicator.innerHTML = `
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" fill="currentColor"/>
              </svg>
            `;
              
              // Add to element
              element.style.position = 'relative';
              element.appendChild(indicator);
          },

          removeIndicators(element) {
              // Remove any existing indicators
              const existingIndicators = element.querySelectorAll('.bundle-builder__position-indicator');
              existingIndicators.forEach(indicator => indicator.remove());
          },

          // New method to just clear active classes without touching indicators
          clearActiveClassesForType(itemType) {
              const currentStepSelector = `.bundle-builder__tab-content[data-step="${this.activeStep}"]`;
              const currentStep = document.querySelector(currentStepSelector);
              
              if (currentStep) {
                  // Find all active elements of this type in the current step and remove the active class only
                  const selector = `.bundle-builder__product-card[data-product-type="${itemType}"] .bundle-builder__product-card-image.active`;
                  const activeElements = currentStep.querySelectorAll(selector);
                  activeElements.forEach(element => {
                      element.classList.remove('active');
                  });
              }
          },

          setIndicatorsOnStepChange() {
              // Use Vue's nextTick instead of setTimeout
              this.$nextTick(() => {
                  const currentStepSelector = `.bundle-builder__tab-content[data-step="${this.activeStep}"]`;
                  const currentStep = document.querySelector(currentStepSelector);
                  
                  if (!currentStep) return;
                  
                  // Get current step's item type - without optional chaining
                  const currentStepData = this.bundleData.steps[this.activeStep];
                  const stepItemTypes = currentStepData && currentStepData.collections ? 
                    currentStepData.collections.map(c => c.item_type) : [];
                  
                  // Process each item type relevant to this step
                  stepItemTypes.forEach(itemType => {
                      // Skip if this item type has no selections
                      if (!this.activeSelections[itemType] || this.activeSelections[itemType].length === 0) return;
                      
                      // Handle each selected product of this type
                      this.activeSelections[itemType].forEach(productId => {
                          const product = this.findProductById(productId);
                          if (!product) return;
                          
                          // Find the product element
                          const selector = `.bundle-builder__product-card-image[data-product-id="${productId}"]`;
                          const element = currentStep.querySelector(selector);
                          if (!element) return;
                          
                          // Add active class
                          element.classList.add('active');
                          
                          // First remove all indicators to start fresh when changing steps
                          this.removeAllIndicators(element);
                          
                          // Add appropriate indicator based on item type and set size
                          if (itemType === 'Servingware') {
                              // Determine which slot this servingware is in
                              for (let i = 1; i <= 3; i++) {
                                  if (this.visualiser.servingware[`slot_${i}_id`] === productId) {
                                      // Add slot number without the 'S' prefix
                                      this.addPlaceNumberIndicator(element, i);
                                  }
                              }
                          } else {
                              const setSize = product.set_size || 1;
                              const baseProperty = {
                                  'Placemat': 'placemat',
                                  'Plate': 'plate',
                                  'Napkin': 'napkin',
                                  'Bowl': 'bowl',
                                  'Cutlery': 'cutlery',
                                  'Glassware': 'glassware'
                              }[itemType];
                              
                              if (setSize === 4) {
                                  // Add checkmark for full sets
                                  this.addCheckmarkIndicator(element);
                              } else {
                                  // For individual items, add place number indicators for each place it's used
                                  for (let i = 1; i <= 4; i++) {
                                      const place = `place${i}`;
                                      if (this.visualiser[place][`${baseProperty}_id`] === productId) {
                                          this.addPlaceNumberIndicator(element, i);
                                      }
                                  }
                              }
                          }
                      });
                  });
              });
          },

          removeAllIndicators(element) {
              // Remove any existing indicators
              const existingIndicators = element.querySelectorAll('.bundle-builder__position-indicator');
              existingIndicators.forEach(indicator => indicator.remove());
          },

          removeIndicator(element, placeNumber) {
              // Remove only the specific indicator matching the place number
              const indicator = element.querySelector(`.bundle-builder__position-indicator-${placeNumber}`);
              if (indicator) {
                  indicator.remove();
              }
          },

          handlePlaceSettingRemoval(productId, placeNumber) {
              // Find product elements that match this product id
              const selector = `.bundle-builder__product-card-image[data-product-id="${productId}"]`;
              const elements = document.querySelectorAll(selector);
              
              elements.forEach(element => {
                  // Remove only the specific indicator
                  this.removeIndicator(element, placeNumber);
              });
          },

          // Add this helper method to find which place an item is in
          findItemPlacement(id, itemType) {
            const baseProperty = {
              'Placemat': 'placemat', 
              'Plate': 'plate',
              'Napkin': 'napkin',
              'Bowl': 'bowl',
              'Cutlery': 'cutlery',
              'Glassware': 'glassware'
            }[itemType];
            
            if (baseProperty) {
              // Check each place setting for this item
              for (let i = 1; i <= 4; i++) {
                const place = `place${i}`;
                if (this.visualiser[place][`${baseProperty}_id`] === id) {
                  return i; // Return the place number
                }
              }
            }
            
            // For servingware
            if (itemType === 'Servingware') {
              for (let i = 1; i <= 3; i++) {
                if (this.visualiser.servingware[`slot_${i}_id`] === id) {
                  return i; // Return just the number, not 'S'+i
                }
              }
            }
            
            return null;
          },
          // Helper method to count how many times a product appears in place settings
          countProductInPlaces(productId, itemType) { 
              let count = 0;
              const baseProperty = {
                  'Placemat': 'placemat',
                  'Plate': 'plate',
                  'Napkin': 'napkin',
                  'Bowl': 'bowl',
                  'Cutlery': 'cutlery',
                  'Glassware': 'glassware'
              }[itemType];
              
              if (itemType === 'Servingware') {
                  for (let i = 1; i <= 3; i++) {
                      if (this.visualiser.servingware[`slot_${i}_id`] === productId) {
                          count++;
                      }
                  }
              } else if (baseProperty) {
                  for (let i = 1; i <= 4; i++) {
                      const place = `place${i}`;
                      if (this.visualiser[place][`${baseProperty}_id`] === productId) {
                          count++;
                      }
                  }
              }
              
              return count;
          },
          // Helper function to count how many of a product is in the bundle
          countProductInBundle(productId) {
              const bundleItem = this.bundleContents.find(item => item.id === productId);
              return bundleItem ? bundleItem.quantity : 0;
          }
        },
        watch: {
          activeStep() {
              // Set indicators when step changes
              this.setIndicatorsOnStepChange();
          }
        },
        mounted() {
          this.mounted = true;
          console.log('mounted!:',  this.mounted);
        }
      }).mount('#app');
    };

  const Cart = () => {
    const { createApp } = window.Vue;

    createApp({
      data() {
        return {
          // eslint-disable-next-line no-undef
          cartState: initialCart,
          mounted: false,
          hasBundle: false,
          // loading: true,
          shipping_price: '$6.50',
          // eslint-disable-next-line no-undef
          total_price: initialCart.items_subtotal_price,
          cartUpsells: window.cartUpsells || [],
          eligibleUpsells: [],
          showUpsells: false
        }
      }, 
      methods: {
        updateCartState() {
          return this.$nextTick()
            .then(() => { 
              return fetch('/cart.js') 

                .then(response => response.json())
                .then(data => {
                  this.bundleProducts = [];
                  this.standardProducts = [];
                  data.items.map((item) => {
                      if(item.properties.bundle_id) {
                          this.bundleProducts.push(item);
                          this.hasBundle = true;
                      } else {
                          this.standardProducts.push(item);
                      }
                  });
                  this.cartState = data;
                  // this.updateProgressBar()
                  this.checkUpsellEligibility().then(() => {
                    // Reinitialize Flickity after upsells update
                    this.$nextTick(() => {
                      setTimeout(() => {
                        this.initUpsellSwipers();
                      }, 200);
                    });
                  });
                })
                .catch(error => {
                  console.error('Error updating cart state:', error);
                })
            })
        },
        formatMoney (cents, format) {
          if (typeof cents == 'string') {
          cents = cents.replace('.', '');
          }
          var value = '';
          var placeholderRegex = /{{\s*(\w+)\s*}}/;
          var formatString = (format || this.money_format);

          function formatWithDelimiters(number, precision, thousands, decimal) {
              precision = 2;
              thousands =',';
              decimal = '.';
              if (isNaN(number) || number == null) {
                  return 0;
              }
              number = (number / 100.0).toFixed(precision);
              var parts = number.split('.'),
                  dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                  cents = parts[1] ? (decimal + parts[1]) : '';
              return dollars + cents;
          }
          switch (formatString.match(placeholderRegex)[1]) {
              case 'amount':
                  value = formatWithDelimiters(cents, 2);
                  break;
              case 'amount_no_decimals':
                  value = formatWithDelimiters(cents, 0);
                  break;
              case 'amount_with_comma_separator':
                  value = formatWithDelimiters(cents, 2, '.', ',');
                  break;
              case 'amount_no_decimals_with_comma_separator':
                  value = formatWithDelimiters(cents, 0, '.', ',');
                  break;
          }
          return formatString.replace(placeholderRegex, value);
          },
        updateProgressBar() {
          return this.$nextTick()
            .then(() => {
              if(this.cartState.items_subtotal_price >= 2500) {
                  this.$refs.cartProgressBar.setAttribute('style', `--progress: 100%;`);
                  this.$refs.cartPromotionMessage.innerHTML = "You've qualified for Free Shipping!";
                  this.$refs.cartPromotionMessage.classList.add('itallics');
                  this.shipping_price = 'FREE!';
              } else {
                  let progress = ((this.cartState.items_subtotal_price / 2500) * 100).toFixed(2);
                  this.$refs.cartProgressBar.setAttribute('style', `--progress: ${progress}%;`);
                  this.shipping_price = '$6.50';
                  this.total_price = this.cartState.items_subtotal_price + 589;
                  this.$refs.cartPromotionMessage.innerHTML = `You are ${this.currency((2500 - this.cartState.items_subtotal_price))} away from Free Shipping`;
              }
            })
        },
        addToCart(id, quantity, container) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            }, 
            body: JSON.stringify({
              "id": `${id}`,
              "quantity": Number(quantity + 1)
            })
          })
          .then((response) => {
            if (!response.ok) {
              return response.json().then(data => {
                throw new Error(data.description || `Error ${response.status}: ${response.statusText}`);
              });
            }
            return response.json();
          })
          .then(() => this.updateCartState())
          .catch((error) => {
            console.error('Error:', error);
            container.closest('.cart-item').querySelector('.cart-error').innerHTML = 'You already have all available stock in your cart';
            setTimeout(() => {
              container.closest('.cart-item').querySelector('.cart-error').innerHTML = '';
            }, 3000);
          });
        },
        async subtractFromCart(id, quantity) {
          this.loading = true;
          
          // Get the product ID of the item being removed before removing it
          const itemToRemove = this.cartState.items.find(item => item.variant_id === id);
          const productIdToRemove = itemToRemove ? String(itemToRemove.product_id) : null;
          
          // Check if this item is a qualifying product for any upsell items
          let isQualifyingProduct = false;
          if (productIdToRemove) {
            for (const item of this.cartState.items) {
              if (item.properties && item.properties._upsell_qualifying_products) {
                const qualifyingIds = item.properties._upsell_qualifying_products.split(',').filter(id => id);
                if (qualifyingIds.includes(productIdToRemove)) {
                  isQualifyingProduct = true;
                  break;
                }
              }
            }
          }
          
          try {
            const response = await fetch('/cart/change.js', {
              method: 'POST', // or 'PUT'
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                "id": `${id}`,
                "quantity": Number(quantity - 1)
              })
            });
            
            await response.json();
            
            // Update cart state first
            await this.updateCartState();
            
            // Only check for dependent upsell items if a qualifying product was removed/reduced
            // This checks if threshold is still met after the removal
            if (productIdToRemove && isQualifyingProduct) {
              await this.removeDependentUpsellItems(productIdToRemove);
            }
          } catch (error) {
            console.error('Error:', error);
          }
        },
        currency(price) {
          // eslint-disable-next-line no-undef
          return this.formatMoney(price, Shopify.money_format)
        },
        getDiscountedPrice(price, discountPercent) {
          if (!discountPercent || discountPercent <= 0) {
            return price;
          }
          // Ensure price is in cents (convert if it appears to be in dollars)
          let priceInCents = price;
          if (price > 0 && price < 1000) {
            // Likely in dollars, convert to cents
            priceInCents = Math.round(price * 100);
          }
          // Calculate discount and round to nearest cent
          return Math.round(priceInCents * (1 - discountPercent / 100));
        },
        ensurePriceInCents(price) {
          // Convert price to cents if it appears to be in dollars
          if (price > 0 && price < 1000) {
            return Math.round(price * 100);
          }
          return price;
        },
        getCartItemPrice(item) {
          // Check if item has upsell discount property
          const discountPercent = item.properties && item.properties._upsell_discount 
            ? parseFloat(item.properties._upsell_discount) 
            : null;
          
          if (discountPercent && discountPercent > 0) {
            return this.getDiscountedPrice(item.price, discountPercent);
          }
          return item.price;
        },
        hasUpsellDiscount(item) {
          return item.properties && item.properties._upsell_discount && parseFloat(item.properties._upsell_discount) > 0;
        },
        getUpsellDiscountPercent(item) {
          if (this.hasUpsellDiscount(item)) {
            return parseFloat(item.properties._upsell_discount);
          }
          return null;
        },
        removeBundle() {
          this.loading = true;
          let updates = {};
          this.bundleProducts.map((product) => {
              updates[product.key] = 0;
          });
          const clearBundle = () => {
              this.updateCartState();
              this.hasBundle = false;
          };
          fetch(`${window.Shopify.routes.root}cart/update.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                updates
              })
            })
            .then((response) => response.json())
            // eslint-disable-next-line no-unused-vars
            .then((data) => clearBundle())
            .catch((error) => {
              console.error('Error:', error);
            });
        },
        renderBundleContents() {
          let bundleHTML= '';
          let bundlePrice = 0;

          // eslint-disable-next-line no-unused-vars
          this.bundleProducts.map((item, i) => {
              if(!item.properties.bundle_id) {
                  return;
              } 
                  bundlePrice += (item.price * item.quantity);
                  bundleHTML += `
                    <li class="tiny text--grey">${item.quantity}x ${item.title}</li>
                `;
          });

          return `
        <p>${this.currency(bundlePrice)}</p>
        <details>
            <summary class="flex flex-r flex-middle gap--s w-fit">
            Tablescape Contents
            </summary>
            <ul>${bundleHTML}</ul>
        </details>
        `
        },
        openCartDrawer() {
          const cartDrawer = document.querySelector('[data-cart-drawer]');
          cartDrawer.classList.add('active');
        },
        addListeners() {
          document.addEventListener('theme:product:add', this.updateCartState);
          document.addEventListener('theme:product:added', this.openCartDrawer);
        },
        async checkUpsellEligibility() {
          console.log('checkUpsellEligibility called', {
            cartUpsells: this.cartUpsells,
            cartUpsellsLength: this.cartUpsells?.length,
            cartItems: this.cartState.items?.length
          });
          
          if (!this.cartUpsells || this.cartUpsells.length === 0) {
            console.log('No cart upsells configured');
            this.showUpsells = false;
            this.eligibleUpsells = [];
            return;
          }

          this.eligibleUpsells = [];
          
          if (!this.cartState || !this.cartState.items || this.cartState.items.length === 0) {
            console.log('Cart is empty, no upsells to show');
            this.showUpsells = false;
            this.eligibleUpsells = [];
            return;
          }
          
          // Create a map of product_id to total quantity for counting items
          const cartProductQuantities = {};
          this.cartState.items.forEach(item => {
            const productId = String(item.product_id);
            cartProductQuantities[productId] = (cartProductQuantities[productId] || 0) + item.quantity;
          });
          
          const cartProductIds = Object.keys(cartProductQuantities);
          const allEligibleUpsells = [];
          
          console.log('Cart product IDs:', cartProductIds);
          console.log('Cart product quantities:', cartProductQuantities);

          // Check each upsell rule
          for (const upsell of this.cartUpsells) {
            // Get handles directly from Liquid (should be resolved server-side)
            let requiredHandle = upsell.collection_required_handle;
            let offeredHandle = upsell.collection_offered_handle;
            
            // If handles are null, try to extract from GID if available
            if (!requiredHandle && upsell.collection_required_gid) {
              const gidMatch = String(upsell.collection_required_gid).match(/Collection\/(\d+)/);
              if (gidMatch) {
                // We have the collection ID but need the handle
                // Unfortunately, we can't easily look this up client-side
                // This should be resolved in Liquid
                console.warn('Collection GID found but handle is null:', upsell.collection_required_gid);
              }
            }
            
            if (!offeredHandle && upsell.collection_offered_gid) {
              const gidMatch = String(upsell.collection_offered_gid).match(/Collection\/(\d+)/);
              if (gidMatch) {
                console.warn('Collection GID found but handle is null:', upsell.collection_offered_gid);
              }
            }
            
            if (!requiredHandle || !offeredHandle) {
              console.warn('Missing collection handles for upsell:', {
                name: upsell.upsell_name,
                required_handle: requiredHandle,
                offered_handle: offeredHandle,
                required_gid: upsell.collection_required_gid,
                offered_gid: upsell.collection_offered_gid
              });
              continue;
            }

            try {
              // Get collection product IDs from pre-rendered data (much faster than API calls)
              const collectionsDataScript = document.querySelector('[data-collections-data]');
              let requiredProductIds = [];
              let offeredProductIds = [];
              
              if (collectionsDataScript) {
                try {
                  const collectionsData = JSON.parse(collectionsDataScript.textContent);
                  if (collectionsData[requiredHandle] && Array.isArray(collectionsData[requiredHandle])) {
                    requiredProductIds = collectionsData[requiredHandle].map(id => String(id));
                  } else {
                    console.warn(`Collection "${requiredHandle}" not found in pre-rendered data`);
                    continue;
                  }
                  
                  // Check if any products from offered collection are already in cart
                  if (collectionsData[offeredHandle] && Array.isArray(collectionsData[offeredHandle])) {
                    offeredProductIds = collectionsData[offeredHandle].map(id => String(id));
                    const hasOfferedProductInCart = cartProductIds.some(id => offeredProductIds.includes(id));
                    if (hasOfferedProductInCart) {
                      // Skip this upsell if a product from offered collection is already in cart
                      continue;
                    }
                  }
                } catch (error) {
                  console.error('Error parsing collections data:', error);
                  continue;
                }
              } else {
                console.warn('Collections data script not found. Falling back to API call.');
                // Fallback to API if pre-rendered data not available
                let collectionUrl = `/collections/${requiredHandle}.js`;
                let collectionResponse = await fetch(collectionUrl);
                
                if (!collectionResponse.ok && collectionResponse.status === 404) {
                  collectionUrl = `/collections/${requiredHandle}/products.json`;
                  collectionResponse = await fetch(collectionUrl);
                }
                
                if (!collectionResponse.ok) {
                  console.warn(`Collection not found: "${requiredHandle}"`);
                  continue;
                }
                
                const collectionData = await collectionResponse.json();
                let products = [];
                if (collectionData.products) {
                  products = collectionData.products;
                } else if (Array.isArray(collectionData)) {
                  products = collectionData;
                } else if (collectionData.collection && collectionData.collection.products) {
                  products = collectionData.collection.products;
                }
                
                if (!products || products.length === 0) {
                  console.warn(`No products found in collection: ${requiredHandle}`);
                  continue;
                }
                
                requiredProductIds = products.map(p => String(p.id));
                
                // Check if any products from offered collection are already in cart (API fallback)
                let offeredCollectionUrl = `/collections/${offeredHandle}/products.json`;
                let offeredCollectionResponse = await fetch(offeredCollectionUrl);
                
                if (!offeredCollectionResponse.ok && offeredCollectionResponse.status === 404) {
                  offeredCollectionUrl = `/collections/${offeredHandle}.js`;
                  offeredCollectionResponse = await fetch(offeredCollectionUrl);
                }
                
                if (offeredCollectionResponse.ok) {
                  const offeredCollectionData = await offeredCollectionResponse.json();
                  let offeredProducts = [];
                  if (offeredCollectionData.products) {
                    offeredProducts = offeredCollectionData.products;
                  } else if (Array.isArray(offeredCollectionData)) {
                    offeredProducts = offeredCollectionData;
                  } else if (offeredCollectionData.collection && offeredCollectionData.collection.products) {
                    offeredProducts = offeredCollectionData.collection.products;
                  }
                  
                  if (offeredProducts && offeredProducts.length > 0) {
                    offeredProductIds = offeredProducts.map(p => String(p.id));
                    const hasOfferedProductInCart = cartProductIds.some(id => offeredProductIds.includes(id));
                    if (hasOfferedProductInCart) {
                      // Skip this upsell if a product from offered collection is already in cart
                      continue;
                    }
                  }
                }
              }

              // Count total quantity of items from required collection in cart
              let totalMatchingQuantity = 0;
              const matchingProductIds = [];
              cartProductIds.forEach(productId => {
                if (requiredProductIds.includes(productId)) {
                  totalMatchingQuantity += cartProductQuantities[productId];
                  matchingProductIds.push(productId);
                }
              });

              console.log(`Upsell ${upsell.upsell_name}: ${totalMatchingQuantity} items from collection (need ${upsell.number_of_products_from_collection_required})`);

              // Check if threshold is met (count total quantity, not unique products)
              if (totalMatchingQuantity >= upsell.number_of_products_from_collection_required) {
                // Fetch products for this eligible upsell
                const upsellWithHandle = {...upsell, collection_offered_handle: offeredHandle};
                const upsellProducts = await this.fetchUpsellProducts(upsellWithHandle, cartProductIds);
                if (upsellProducts && upsellProducts.length > 0) {
                  // Store the qualifying product IDs that made this upsell eligible
                  const qualifyingProductIds = matchingProductIds;
                  allEligibleUpsells.push({
                    ...upsell,
                    products: upsellProducts,
                    qualifyingProductIds: qualifyingProductIds
                  });
                }
              }
            } catch (error) {
              console.error(`Error checking upsell eligibility for ${upsell.upsell_name}:`, error);
            }
          }

          // If multiple upsells are eligible, show only the one requiring the most items
          if (allEligibleUpsells.length > 0) {
            // Sort by number_of_products_from_collection_required in descending order
            allEligibleUpsells.sort((a, b) => {
              return (b.number_of_products_from_collection_required || 0) - (a.number_of_products_from_collection_required || 0);
            });
            // Keep only the first one (highest requirement)
            this.eligibleUpsells = [allEligibleUpsells[0]];
            console.log('Eligible upsells found:', this.eligibleUpsells);
          } else {
            console.log('No eligible upsells found. allEligibleUpsells:', allEligibleUpsells);
          }

          this.showUpsells = this.eligibleUpsells.length > 0;
          console.log('showUpsells set to:', this.showUpsells);
          
          // Initialize Flickity after upsells are loaded
          // Wait for Vue to render DOM and scripts to load
          this.$nextTick(() => {
            // Give Vue time to render the DOM elements
            setTimeout(() => {
              this.initUpsellSwipers();
            }, 100);
          });
        },
        initUpsellSwipers() {
          // Initialize Flickity for each upsell section
          const carouselContainers = document.querySelectorAll('.cart__upsells-carousel');
          
          if (carouselContainers.length === 0) {
            return; // No carousels to initialize
          }
          
          // Wait for Flickity to be available (vendor.js loads with defer)
          let retryCount = 0;
          const maxRetries = 50; // 5 seconds max wait
          
          const initFlickity = () => {
            // Try multiple ways to access Flickity
            let Flickity = null;
            
            // Check global Flickity first
            if (window.Flickity) {
              Flickity = window.Flickity;
            } 
            // Check if themeVendor is available and has Flickity
            else if (window.themeVendor && window.themeVendor.Flickity) {
              Flickity = window.themeVendor.Flickity;
            }
            // Check if it's exposed through theme object
            else if (window.theme && window.theme.Flickity) {
              Flickity = window.theme.Flickity;
            }
            
            if (!Flickity) {
              retryCount++;
              if (retryCount < maxRetries) {
                // Retry after a short delay if Flickity isn't loaded yet
                setTimeout(initFlickity, 100);
              } else {
                console.warn('Flickity JS not loaded after waiting. Make sure vendor.js is loaded.');
              }
              return;
            }
            
            carouselContainers.forEach((container) => {
              // Skip if already initialized
              if (container.flickityGUID) {
                const existingFlkty = Flickity.data(container);
                if (existingFlkty) {
                  existingFlkty.destroy();
                }
              }
              
              // For fractional displays (1.2, 2.3), don't use groupCells
              // Let CSS widths control the display
              const getGroupCells = () => {
                const width = window.innerWidth;
                if (width >= 1024) return 3;   // 3 columns on desktop
                return false;                   // No grouping for tablet/mobile (CSS handles fractional display)
              };
              
              try {
                const width = window.innerWidth;
                const cellAlign = width <= 767 ? 'center' : 'left';
                
                const flkty = new Flickity(container, {
                  cellAlign: cellAlign,
                  contain: true,
                  prevNextButtons: true,
                  pageDots: true,
                  wrapAround: false,
                  groupCells: getGroupCells(),
                  adaptiveHeight: false,
                  freeScroll: false,
                  watchCSS: false,
                  resize: true,
                  setGallerySize: true
                });
                
                // Force resize after initialization to ensure proper sizing
                setTimeout(() => {
                  if (flkty) {
                    flkty.resize();
                  }
                }, 50);
              } catch (error) {
                console.error('Error initializing Flickity:', error);
              }
            });
          };
          
          // Start initialization
          initFlickity();
        },
        async fetchUpsellProducts(upsell, cartProductIds) {
          if (!upsell || !upsell.collection_offered_handle) return [];

          try {
            // Get eligible product IDs from pre-rendered data (faster filtering)
            const collectionsDataScript = document.querySelector('[data-collections-data]');
            let eligibleProductIds = [];
            
            if (collectionsDataScript) {
              try {
                const collectionsData = JSON.parse(collectionsDataScript.textContent);
                if (collectionsData[upsell.collection_offered_handle] && Array.isArray(collectionsData[upsell.collection_offered_handle])) {
                  // Filter out products already in cart using pre-rendered IDs
                  eligibleProductIds = collectionsData[upsell.collection_offered_handle]
                    .map(id => String(id))
                    .filter(id => !cartProductIds.includes(id))
                    .slice(0, 6); // Limit to 6 products
                }
              } catch (error) {
                console.error('Error parsing collections data:', error);
              }
            }
            
            // Still need to fetch full product data for display (images, prices, etc.)
            // But we can optimize by only processing products we know are eligible
            let collectionUrl = `/collections/${upsell.collection_offered_handle}/products.json`;
            let collectionResponse = await fetch(collectionUrl);
            
            if (!collectionResponse.ok && collectionResponse.status === 404) {
              collectionUrl = `/collections/${upsell.collection_offered_handle}.js`;
              collectionResponse = await fetch(collectionUrl);
            }
            
            if (!collectionResponse.ok) {
              console.warn(`Collection not found: "${upsell.collection_offered_handle}"`);
              return [];
            }
            
            const collectionData = await collectionResponse.json();
            
            // Handle different response formats
            let allProducts = [];
            if (collectionData.products) {
              allProducts = collectionData.products;
            } else if (Array.isArray(collectionData)) {
              allProducts = collectionData;
            } else if (collectionData.collection && collectionData.collection.products) {
              allProducts = collectionData.collection.products;
            }
            
            if (!allProducts || allProducts.length === 0) {
              return [];
            }
            
            // Filter products using pre-rendered IDs if available, otherwise filter by cart
            let filteredProducts;
            if (eligibleProductIds.length > 0) {
              // Use pre-rendered IDs for faster filtering
              filteredProducts = allProducts.filter(product => 
                eligibleProductIds.includes(String(product.id))
              );
            } else {
              // Fallback: filter by cart product IDs
              filteredProducts = allProducts.filter(product => 
                !cartProductIds.includes(String(product.id))
              ).slice(0, 6);
            }
            
            // Format product data
            return filteredProducts
              .filter(product => !cartProductIds.includes(String(product.id)))
              .map(product => {
                // Handle different image formats
                let imageUrl = '';
                if (product.featured_image) {
                  imageUrl = typeof product.featured_image === 'string' 
                    ? product.featured_image 
                    : product.featured_image.url || product.featured_image.src || '';
                } else if (product.images && product.images.length > 0) {
                  imageUrl = typeof product.images[0] === 'string' 
                    ? product.images[0] 
                    : product.images[0].url || product.images[0].src || '';
                } else if (product.image) {
                  imageUrl = typeof product.image === 'string' 
                    ? product.image 
                    : product.image.url || product.image.src || '';
                }
                
                // Shopify collections API returns prices in cents
                // Ensure we're working with numbers, not strings
                let productPrice = product.variants?.[0]?.price || product.price || 0;
                let productComparePrice = product.variants?.[0]?.compare_at_price || product.compare_at_price || null;
                
                // Convert to numbers if they're strings
                productPrice = typeof productPrice === 'string' ? parseFloat(productPrice) : productPrice;
                if (productComparePrice) {
                  productComparePrice = typeof productComparePrice === 'string' ? parseFloat(productComparePrice) : productComparePrice;
                }
                
                return {
                  id: product.id,
                  title: product.title,
                  url: product.url || `/products/${product.handle || product.id}`,
                  featured_image: imageUrl,
                  image: imageUrl, // Also set image for fallback
                  variants: product.variants || [product],
                  price: productPrice,
                  compare_at_price: productComparePrice
                };
              })
              .slice(0, 6); // Limit to 6 products per upsell
          } catch (error) {
            console.error('Error fetching upsell products:', error);
            return [];
          }
        },
        async addUpsellToCart(variantId, discount, qualifyingProductIds, requiredHandle, threshold) {
          try {
            // Store qualifying product IDs as a comma-separated string in properties
            const qualifyingIdsString = qualifyingProductIds && qualifyingProductIds.length > 0
              ? qualifyingProductIds.join(',')
              : '';
            
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                id: variantId,
                quantity: 1,
                properties: {
                  '_upsell_discount': discount,
                  '_upsell_qualifying_products': qualifyingIdsString,
                  '_upsell_required_collection': requiredHandle || '',
                  '_upsell_threshold': threshold || ''
                }
              })
            });

            if (!response.ok) {
              const errorData = await response.json();
              throw new Error(errorData.description || 'Failed to add product to cart');
            }

            await this.updateCartState();
          } catch (error) {
            console.error('Error adding upsell to cart:', error);
            alert('Failed to add product to cart. Please try again.');
          }
        },
        async removeDependentUpsellItems(removedProductId) {
          // Find all cart items that have this product ID as a qualifying product
          const itemsToCheck = [];
          
          for (const item of this.cartState.items) {
            if (item.properties && item.properties._upsell_qualifying_products) {
              const qualifyingIds = item.properties._upsell_qualifying_products.split(',').filter(id => id);
              if (qualifyingIds.includes(String(removedProductId))) {
                itemsToCheck.push(item);
              }
            }
          }
          
          // Check each upsell item to see if threshold is still met
          const itemsToRemove = [];
          const collectionsDataScript = document.querySelector('[data-collections-data]');
          
          // Create a map of product_id to total quantity for counting items
          const cartProductQuantities = {};
          this.cartState.items.forEach(item => {
            const productId = String(item.product_id);
            cartProductQuantities[productId] = (cartProductQuantities[productId] || 0) + item.quantity;
          });
          const cartProductIds = Object.keys(cartProductQuantities);
          
          for (const upsellItem of itemsToCheck) {
            const requiredHandle = upsellItem.properties._upsell_required_collection;
            const threshold = parseInt(upsellItem.properties._upsell_threshold) || 0;
            
            if (!requiredHandle || threshold === 0) {
              // If we don't have the required info, remove the item to be safe
              itemsToRemove.push(upsellItem.key);
              continue;
            }
            
            // Get product IDs from the required collection
            let requiredProductIds = [];
            
            if (collectionsDataScript) {
              try {
                const collectionsData = JSON.parse(collectionsDataScript.textContent);
                if (collectionsData[requiredHandle] && Array.isArray(collectionsData[requiredHandle])) {
                  requiredProductIds = collectionsData[requiredHandle].map(id => String(id));
                }
              } catch (error) {
                console.error('Error parsing collections data:', error);
              }
            }
            
            // Count total quantity of items from required collection still in cart
            let totalMatchingQuantity = 0;
            cartProductIds.forEach(productId => {
              if (requiredProductIds.includes(productId)) {
                totalMatchingQuantity += cartProductQuantities[productId];
              }
            });
            
            // If threshold is no longer met, remove the upsell item
            if (totalMatchingQuantity < threshold) {
              itemsToRemove.push(upsellItem.key);
            }
          }
          
          // Remove all upsell items that no longer meet the threshold
          if (itemsToRemove.length > 0) {
            const updates = {};
            itemsToRemove.forEach(key => {
              updates[key] = 0;
            });
            
            try {
              await fetch(`${window.Shopify.routes.root}cart/update.js`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });
              
              await this.updateCartState();
            } catch (error) {
              console.error('Error removing dependent upsell items:', error);
            }
          }
        }
      },
      mounted() {
          this.updateCartState();
          this.addListeners();
          this.mounted=true;
        

      }
    }).mount('#app');
  };

  const CartDrawer = () => {
    const { createApp } = window.Vue;

    createApp({
      data() {
        return {
          // eslint-disable-next-line no-undef
          cartState: initialCart,
          mounted: false,
          hasBundle: false,
          shipping_price: '$6.50',
          // eslint-disable-next-line no-undef
          total_price: initialCart.items_subtotal_price,
          greetingCardsActive: window.theme.greetingCards && window.theme.greetingCards.active ? window.theme.greetingCards.active : false,
          greetingCardVariantIds: window.theme.greetingCards && window.theme.greetingCards.freeGreetingCards ? window.theme.greetingCards.freeGreetingCards : [],
          greetingCardProducts: (window.theme.greetingCards && window.theme.greetingCards.freeGreetingCards)
          ? window.theme.greetingCards.freeGreetingCards
          : [],        
          hoveredCard: null,
          greetingCardInCart: null,
          giftDrawerOpen: false,
          upsellDrawerOpen: false,
          bundleProducts: [],
          standardProducts: [],
          cartUpsells: window.cartUpsells || [],
          eligibleUpsells: [],
          showUpsells: false
        }
      },
      computed: {
        showGreetingCardsSection() {
          return this.cartState.items.some(item => item.product_type !== 'greeting-card');
        }
      },
      methods: {
        initCartDrawer () {
          const cartDrawer = document.querySelector('[data-cart-drawer]');
          const cartDrawerToggle = document.querySelectorAll('[data-cart-toggle]');
          const cartDrawerOverlay = document.querySelector('[data-cart-drawer-overlay]');

          cartDrawerToggle.forEach(toggle => {
            toggle.addEventListener('click', (e) => {
              e.preventDefault();
              cartDrawer.classList.toggle('active');
            });
          });

          cartDrawerOverlay.addEventListener('click', this.closeCartDrawer);
        },
        closeCartDrawer() {
          const cartDrawer = document.querySelector('[data-cart-drawer]');
          cartDrawer.classList.remove('active');
        },
        updateCartState() {
          return this.$nextTick()
            .then(() => {
              return fetch('/cart.js')
                .then(response => response.json())
                .then(data => {
                  this.bundleProducts = [];
                  this.standardProducts = [];
                  data.items.map((item) => {
                      if(item.properties.bundle_id) {
                          this.bundleProducts.push(item);
                          this.hasBundle = true;
                      } else {
                          this.standardProducts.push(item);
                      }
                  });
                  this.cartState = data;
                  // this.updateProgressBar()
                  this.checkUpsellEligibility();
                })
                .catch(error => {
                  console.error('Error updating cart state:', error);
                })
            })
        },
        formatMoney (cents, format) {
          if (typeof cents == 'string') {
          cents = cents.replace('.', '');
          }
          var value = '';
          var placeholderRegex = /{{\s*(\w+)\s*}}/;
          var formatString = (format || this.money_format);

          function formatWithDelimiters(number, precision, thousands, decimal) {
              precision = 2;
              thousands =',';
              decimal = '.';
              if (isNaN(number) || number == null) {
                  return 0;
              }
              number = (number / 100.0).toFixed(precision);
              var parts = number.split('.'),
                  dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                  cents = parts[1] ? (decimal + parts[1]) : '';
              return dollars + cents;
          }
          switch (formatString.match(placeholderRegex)[1]) {
              case 'amount':
                  value = formatWithDelimiters(cents, 2);
                  break;
              case 'amount_no_decimals':
                  value = formatWithDelimiters(cents, 0);
                  break;
              case 'amount_with_comma_separator':
                  value = formatWithDelimiters(cents, 2, '.', ',');
                  break;
              case 'amount_no_decimals_with_comma_separator':
                  value = formatWithDelimiters(cents, 0, '.', ',');
                  break;
          }
          return formatString.replace(placeholderRegex, value);
          },
        updateProgressBar() {
          return this.$nextTick()
            .then(() => {
              if(this.cartState.items_subtotal_price >= 2500) {
                  this.$refs.cartProgressBar.setAttribute('style', `--progress: 100%;`);
                  this.$refs.cartPromotionMessage.innerHTML = "You've qualified for Free Shipping!";
                  this.$refs.cartPromotionMessage.classList.add('itallics');
                  this.shipping_price = 'FREE!';
              } else {
                  let progress = ((this.cartState.items_subtotal_price / 2500) * 100).toFixed(2);
                  this.$refs.cartProgressBar.setAttribute('style', `--progress: ${progress}%;`);
                  this.shipping_price = '$6.50';
                  this.total_price = this.cartState.items_subtotal_price + 589;
                  this.$refs.cartPromotionMessage.innerHTML = `You are ${this.currency((2500 - this.cartState.items_subtotal_price))} away from Free Shipping`;
              }
            })
        },
        addToCart(id, quantity, container) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            }, 
            body: JSON.stringify({
              "id": `${id}`,
              "quantity": Number(quantity + 1)
            })
          })
          .then((response) => {
            if (!response.ok) {
              return response.json().then(data => {
                throw new Error(data.description || `Error ${response.status}: ${response.statusText}`);
              });
            }
            return response.json();
          })
          .then(() => this.updateCartState())
          .catch((error) => {
            console.error('Error:', error);
            container.closest('.cart-item').querySelector('.cart-error').innerHTML = 'You already have all available stock in your cart';
            setTimeout(() => {
              container.closest('.cart-item').querySelector('.cart-error').innerHTML = '';
            }, 3000);
          });
        },
        async subtractFromCart(id, quantity) {
          this.loading = true;
          // Get product_id before removing to check for dependent upsells
          const itemToRemove = this.cartState.items.find(item => item.variant_id === id);
          const productIdToCheck = itemToRemove ? itemToRemove.product_id : null;
          
          fetch('/cart/change.js', {
            method: 'POST', // or 'PUT'
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              "id": `${id}`,
              "quantity": Number(quantity - 1)
            })
          })
          .then((response) => response.json())
          // eslint-disable-next-line no-unused-vars
          .then(async (data) => {
            await this.updateCartState();
            // Check if we need to remove dependent upsell items
            if (productIdToCheck) {
              await this.removeDependentUpsellItems(productIdToCheck);
            }
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        },
        currency(price) {
          // eslint-disable-next-line no-undef
          return this.formatMoney(price, Shopify.money_format)
        },
        removeBundle() {
          this.loading = true;
          let updates = {};
          this.bundleProducts.map((product) => {
              updates[product.key] = 0;
          });
          const clearBundle = () => {
              this.updateCartState();
              this.hasBundle = false;
          };
          fetch(`${window.Shopify.routes.root}cart/update.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                updates
              })
            })
            .then((response) => response.json())
            // eslint-disable-next-line no-unused-vars
            .then((data) => clearBundle())
            .catch((error) => {
              console.error('Error:', error);
            });
        },
        renderBundleContents() {
          let bundleHTML= '';
          let bundlePrice = 0;

          // eslint-disable-next-line no-unused-vars
          this.bundleProducts.map((item, i) => {
              if(!item.properties.bundle_id) {
                  return;
              } 
                  bundlePrice += (item.price * item.quantity);
                  bundleHTML += `
                    <li class="tiny text--grey">${item.quantity}x ${item.title}</li>
                `;
          });

          return `
        <p>${this.currency(bundlePrice)}</p>
        <details>
            <summary class="flex flex-r flex-middle gap--s w-fit">
            Tablescape Contents
            </summary>
            <ul>${bundleHTML}</ul>
        </details>
        `
        },
        openCartDrawer() {
          const cartDrawer = document.querySelector('[data-cart-drawer]');
          cartDrawer.classList.add('active');
        },
        addGreetingCardToCart(cardID) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: cardID,
              quantity: 1
            })
          })
          .then(response => {
            if (!response.ok) {
              return response.json().then(data => {
                throw new Error(data.description || `Error ${response.status}: ${response.statusText}`);
              });
            }
            return response.json();
          })
          .then(() => this.updateCartState())
          .catch((error) => {
            console.error('Error:', error);
          });
        },
        updateGreetingCardInCart() {
          console.log('updateGreetingCardInCart');
          const card = this.cartState.items.find(item => item.product_type === 'greeting-card');
          this.greetingCardInCart = card
            ? {
                variantId: card.variant_id,
                title: card.title
              }
            : null;
        },
        toggleGiftDrawer() {
          this.giftDrawerOpen = !this.giftDrawerOpen;
          // Close upsell drawer if opening gift drawer
          if (this.giftDrawerOpen) {
            this.upsellDrawerOpen = false;
          }
        },
        toggleUpsellDrawer() {
          this.upsellDrawerOpen = !this.upsellDrawerOpen;
          // Close gift drawer if opening upsell drawer
          if (this.upsellDrawerOpen) {
            this.giftDrawerOpen = false;
          }
          // Initialize Flickity when drawer opens
          if (this.upsellDrawerOpen) {
            this.$nextTick(() => {
              setTimeout(() => {
                this.initUpsellCarousels();
              }, 100);
            });
          }
        },
        getDiscountedPrice(price, discountPercent) {
          if (!discountPercent || discountPercent <= 0) {
            return price;
          }
          // Ensure price is in cents (convert if it appears to be in dollars)
          let priceInCents = price;
          if (price > 0 && price < 1000) {
            // Likely in dollars, convert to cents
            priceInCents = Math.round(price * 100);
          }
          // Calculate discount and round to nearest cent
          return Math.round(priceInCents * (1 - discountPercent / 100));
        },
        ensurePriceInCents(price) {
          // Convert price to cents if it appears to be in dollars
          if (price > 0 && price < 1000) {
            return Math.round(price * 100);
          }
          return price;
        },
        getCartItemPrice(item) {
          // Check if item has upsell discount property
          const discountPercent = item.properties && item.properties._upsell_discount 
            ? parseFloat(item.properties._upsell_discount) 
            : null;
          
          if (discountPercent && discountPercent > 0) {
            return this.getDiscountedPrice(item.price, discountPercent);
          }
          return item.price;
        },
        hasUpsellDiscount(item) {
          return item.properties && item.properties._upsell_discount && parseFloat(item.properties._upsell_discount) > 0;
        },
        getUpsellDiscountPercent(item) {
          if (this.hasUpsellDiscount(item)) {
            return parseFloat(item.properties._upsell_discount);
          }
          return null;
        },
        async checkUpsellEligibility() {
          if (!this.cartUpsells || this.cartUpsells.length === 0) {
            this.showUpsells = false;
            this.eligibleUpsells = [];
            return;
          }

          this.eligibleUpsells = [];
          
          if (!this.cartState || !this.cartState.items || this.cartState.items.length === 0) {
            this.showUpsells = false;
            this.eligibleUpsells = [];
            return;
          }
          
          // Create a map of product_id to total quantity for counting items
          const cartProductQuantities = {};
          this.cartState.items.forEach(item => {
            const productId = String(item.product_id);
            cartProductQuantities[productId] = (cartProductQuantities[productId] || 0) + item.quantity;
          });
          
          const cartProductIds = Object.keys(cartProductQuantities);
          const allEligibleUpsells = [];

          // Check each upsell rule
          for (const upsell of this.cartUpsells) {
            // Get handles directly from Liquid (should be resolved server-side)
            let requiredHandle = upsell.collection_required_handle;
            let offeredHandle = upsell.collection_offered_handle;
            
            if (!requiredHandle || !offeredHandle) {
              continue;
            }

            try {
              // Get collection product IDs from pre-rendered data (much faster than API calls)
              const collectionsDataScript = document.querySelector('[data-collections-data]');
              let requiredProductIds = [];
              let offeredProductIds = [];
              
              if (collectionsDataScript) {
                try {
                  const collectionsData = JSON.parse(collectionsDataScript.textContent);
                  if (collectionsData[requiredHandle] && Array.isArray(collectionsData[requiredHandle])) {
                    requiredProductIds = collectionsData[requiredHandle].map(id => String(id));
                  } else {
                    continue;
                  }
                  
                  // Check if any products from offered collection are already in cart
                  if (collectionsData[offeredHandle] && Array.isArray(collectionsData[offeredHandle])) {
                    offeredProductIds = collectionsData[offeredHandle].map(id => String(id));
                    const hasOfferedProductInCart = cartProductIds.some(id => offeredProductIds.includes(id));
                    if (hasOfferedProductInCart) {
                      // Skip this upsell if a product from offered collection is already in cart
                      continue;
                    }
                  }
                } catch (error) {
                  console.error('Error parsing collections data:', error);
                  continue;
                }
              } else {
                // Fallback to API if pre-rendered data not available
                let collectionUrl = `/collections/${requiredHandle}.js`;
                let collectionResponse = await fetch(collectionUrl);
                
                if (!collectionResponse.ok && collectionResponse.status === 404) {
                  collectionUrl = `/collections/${requiredHandle}/products.json`;
                  collectionResponse = await fetch(collectionUrl);
                }
                
                if (!collectionResponse.ok) {
                  continue;
                }
                
                const collectionData = await collectionResponse.json();
                let products = [];
                if (collectionData.products) {
                  products = collectionData.products;
                } else if (Array.isArray(collectionData)) {
                  products = collectionData;
                } else if (collectionData.collection && collectionData.collection.products) {
                  products = collectionData.collection.products;
                }
                
                if (!products || products.length === 0) {
                  continue;
                }
                
                requiredProductIds = products.map(p => String(p.id));
                
                // Check if any products from offered collection are already in cart (API fallback)
                let offeredCollectionUrl = `/collections/${offeredHandle}/products.json`;
                let offeredCollectionResponse = await fetch(offeredCollectionUrl);
                
                if (!offeredCollectionResponse.ok && offeredCollectionResponse.status === 404) {
                  offeredCollectionUrl = `/collections/${offeredHandle}.js`;
                  offeredCollectionResponse = await fetch(offeredCollectionUrl);
                }
                
                if (offeredCollectionResponse.ok) {
                  const offeredCollectionData = await offeredCollectionResponse.json();
                  let offeredProducts = [];
                  if (offeredCollectionData.products) {
                    offeredProducts = offeredCollectionData.products;
                  } else if (Array.isArray(offeredCollectionData)) {
                    offeredProducts = offeredCollectionData;
                  } else if (offeredCollectionData.collection && offeredCollectionData.collection.products) {
                    offeredProducts = offeredCollectionData.collection.products;
                  }
                  
                  if (offeredProducts && offeredProducts.length > 0) {
                    offeredProductIds = offeredProducts.map(p => String(p.id));
                    const hasOfferedProductInCart = cartProductIds.some(id => offeredProductIds.includes(id));
                    if (hasOfferedProductInCart) {
                      // Skip this upsell if a product from offered collection is already in cart
                      continue;
                    }
                  }
                }
              }

              // Count total quantity of items from required collection in cart
              let totalMatchingQuantity = 0;
              const matchingProductIds = [];
              cartProductIds.forEach(productId => {
                if (requiredProductIds.includes(productId)) {
                  totalMatchingQuantity += cartProductQuantities[productId];
                  matchingProductIds.push(productId);
                }
              });

              // Check if threshold is met (count total quantity, not unique products)
              if (totalMatchingQuantity >= upsell.number_of_products_from_collection_required) {
                // Fetch products for this eligible upsell
                const upsellWithHandle = {...upsell, collection_offered_handle: offeredHandle};
                const upsellProducts = await this.fetchUpsellProducts(upsellWithHandle, cartProductIds);
                if (upsellProducts && upsellProducts.length > 0) {
                  // Store the qualifying product IDs that made this upsell eligible
                  const qualifyingProductIds = matchingProductIds;
                  allEligibleUpsells.push({
                    ...upsell,
                    products: upsellProducts,
                    qualifyingProductIds: qualifyingProductIds
                  });
                }
              }
            } catch (error) {
              console.error(`Error checking upsell eligibility for ${upsell.upsell_name}:`, error);
            }
          }

          // If multiple upsells are eligible, show only the one requiring the most items
          if (allEligibleUpsells.length > 0) {
            // Sort by number_of_products_from_collection_required in descending order
            allEligibleUpsells.sort((a, b) => {
              return (b.number_of_products_from_collection_required || 0) - (a.number_of_products_from_collection_required || 0);
            });
            // Keep only the first one (highest requirement)
            this.eligibleUpsells = [allEligibleUpsells[0]];
          }

          this.showUpsells = this.eligibleUpsells.length > 0;
          
          // Initialize Flickity after upsells are loaded
          // Wait for Vue to render DOM and scripts to load
          this.$nextTick(() => {
            // Give Vue time to render the DOM elements
            setTimeout(() => {
              this.initUpsellCarousels();
            }, 100);
          });
        },
        initUpsellCarousels() {
          // Initialize Flickity for each upsell section in cart drawer
          const carouselContainers = document.querySelectorAll('.cart-drawer__upsell-carousel');
          
          if (carouselContainers.length === 0) {
            return; // No carousels to initialize
          }
          
          // Wait for Flickity to be available (vendor.js loads with defer)
          let retryCount = 0;
          const maxRetries = 50; // 5 seconds max wait
          
          const initFlickity = () => {
            // Try multiple ways to access Flickity
            let Flickity = null;
            
            // Check global Flickity first
            if (window.Flickity) {
              Flickity = window.Flickity;
            } 
            // Check if themeVendor is available and has Flickity
            else if (window.themeVendor && window.themeVendor.Flickity) {
              Flickity = window.themeVendor.Flickity;
            }
            // Check if it's exposed through theme object
            else if (window.theme && window.theme.Flickity) {
              Flickity = window.theme.Flickity;
            }
            
            if (!Flickity) {
              retryCount++;
              if (retryCount < maxRetries) {
                // Retry after a short delay if Flickity isn't loaded yet
                setTimeout(initFlickity, 100);
              } else {
                console.warn('Flickity JS not loaded after waiting. Make sure vendor.js is loaded.');
              }
              return;
            }
            
            carouselContainers.forEach((container) => {
              // Skip if already initialized
              if (container.flickityGUID) {
                const existingFlkty = Flickity.data(container);
                if (existingFlkty) {
                  existingFlkty.destroy();
                }
              }
              
              try {
                // For cart drawer, show 1 product per screen, centered
                const flkty = new Flickity(container, {
                  cellAlign: 'center',
                  contain: true,
                  prevNextButtons: true,
                  pageDots: true,
                  wrapAround: false,
                  groupCells: false, // No grouping - show 1 at a time
                  adaptiveHeight: true,
                  freeScroll: false,
                  watchCSS: false,
                  resize: true,
                  setGallerySize: true
                });
                
                // Force resize after initialization to ensure proper sizing
                setTimeout(() => {
                  if (flkty) {
                    flkty.resize();
                  }
                }, 50);
              } catch (error) {
                console.error('Error initializing Flickity:', error);
              }
            });
          };
          
          // Start initialization
          initFlickity();
        },
        async fetchUpsellProducts(upsell, cartProductIds) {
          if (!upsell || !upsell.collection_offered_handle) return [];

          try {
            // Get eligible product IDs from pre-rendered data (faster filtering)
            const collectionsDataScript = document.querySelector('[data-collections-data]');
            let eligibleProductIds = [];
            
            if (collectionsDataScript) {
              try {
                const collectionsData = JSON.parse(collectionsDataScript.textContent);
                if (collectionsData[upsell.collection_offered_handle] && Array.isArray(collectionsData[upsell.collection_offered_handle])) {
                  // Filter out products already in cart using pre-rendered IDs
                  eligibleProductIds = collectionsData[upsell.collection_offered_handle]
                    .map(id => String(id))
                    .filter(id => !cartProductIds.includes(id))
                    .slice(0, 6); // Limit to 6 products
                }
              } catch (error) {
                console.error('Error parsing collections data:', error);
              }
            }
            
            // Still need to fetch full product data for display (images, prices, etc.)
            let collectionUrl = `/collections/${upsell.collection_offered_handle}/products.json`;
            let collectionResponse = await fetch(collectionUrl);
            
            if (!collectionResponse.ok && collectionResponse.status === 404) {
              collectionUrl = `/collections/${upsell.collection_offered_handle}.js`;
              collectionResponse = await fetch(collectionUrl);
            }
            
            if (!collectionResponse.ok) {
              return [];
            }
            
            const collectionData = await collectionResponse.json();
            
            // Handle different response formats
            let allProducts = [];
            if (collectionData.products) {
              allProducts = collectionData.products;
            } else if (Array.isArray(collectionData)) {
              allProducts = collectionData;
            } else if (collectionData.collection && collectionData.collection.products) {
              allProducts = collectionData.collection.products;
            }
            
            if (!allProducts || allProducts.length === 0) {
              return [];
            }
            
            // Filter products using pre-rendered IDs if available, otherwise filter by cart
            let filteredProducts;
            if (eligibleProductIds.length > 0) {
              // Use pre-rendered IDs for faster filtering
              filteredProducts = allProducts.filter(product => 
                eligibleProductIds.includes(String(product.id))
              );
            } else {
              // Fallback: filter by cart product IDs
              filteredProducts = allProducts.filter(product => 
                !cartProductIds.includes(String(product.id))
              ).slice(0, 6);
            }
            
            // Format product data
            return filteredProducts
              .filter(product => !cartProductIds.includes(String(product.id)))
              .map(product => {
                // Handle different image formats
                let imageUrl = '';
                if (product.featured_image) {
                  imageUrl = typeof product.featured_image === 'string' 
                    ? product.featured_image 
                    : product.featured_image.url || product.featured_image.src || '';
                } else if (product.images && product.images.length > 0) {
                  imageUrl = typeof product.images[0] === 'string' 
                    ? product.images[0] 
                    : product.images[0].url || product.images[0].src || '';
                } else if (product.image) {
                  imageUrl = typeof product.image === 'string' 
                    ? product.image 
                    : product.image.url || product.image.src || '';
                }
                
                // Shopify collections API returns prices in cents
                let productPrice = product.variants?.[0]?.price || product.price || 0;
                let productComparePrice = product.variants?.[0]?.compare_at_price || product.compare_at_price || null;
                
                // Convert to numbers if they're strings
                productPrice = typeof productPrice === 'string' ? parseFloat(productPrice) : productPrice;
                if (productComparePrice) {
                  productComparePrice = typeof productComparePrice === 'string' ? parseFloat(productComparePrice) : productComparePrice;
                }
                
                return {
                  id: product.id,
                  title: product.title,
                  url: product.url || `/products/${product.handle || product.id}`,
                  featured_image: imageUrl,
                  image: imageUrl,
                  variants: product.variants || [product],
                  price: productPrice,
                  compare_at_price: productComparePrice
                };
              })
              .slice(0, 6); // Limit to 6 products per upsell
          } catch (error) {
            console.error('Error fetching upsell products:', error);
            return [];
          }
        },
        async addUpsellToCart(variantId, discount, qualifyingProductIds, requiredHandle, threshold) {
          try {
            // Store qualifying product IDs as a comma-separated string in properties
            const qualifyingIdsString = qualifyingProductIds && qualifyingProductIds.length > 0
              ? qualifyingProductIds.join(',')
              : '';
            
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                id: variantId,
                quantity: 1,
                properties: {
                  '_upsell_discount': discount,
                  '_upsell_qualifying_products': qualifyingIdsString,
                  '_upsell_required_collection': requiredHandle || '',
                  '_upsell_threshold': threshold || ''
                }
              })
            });

            if (!response.ok) {
              const errorData = await response.json();
              throw new Error(errorData.description || 'Failed to add product to cart');
            }

            await this.updateCartState();
          } catch (error) {
            console.error('Error adding upsell to cart:', error);
            alert('Failed to add product to cart. Please try again.');
          }
        },
        async removeDependentUpsellItems(removedProductId) {
          // Find all cart items that have this product ID as a qualifying product
          const itemsToCheck = [];
          
          for (const item of this.cartState.items) {
            if (item.properties && item.properties._upsell_qualifying_products) {
              const qualifyingIds = item.properties._upsell_qualifying_products.split(',').filter(id => id);
              if (qualifyingIds.includes(String(removedProductId))) {
                itemsToCheck.push(item);
              }
            }
          }
          
          // Check each upsell item to see if threshold is still met
          const itemsToRemove = [];
          const collectionsDataScript = document.querySelector('[data-collections-data]');
          
          // Create a map of product_id to total quantity for counting items
          const cartProductQuantities = {};
          this.cartState.items.forEach(item => {
            const productId = String(item.product_id);
            cartProductQuantities[productId] = (cartProductQuantities[productId] || 0) + item.quantity;
          });
          const cartProductIds = Object.keys(cartProductQuantities);
          
          for (const upsellItem of itemsToCheck) {
            const requiredHandle = upsellItem.properties._upsell_required_collection;
            const threshold = parseInt(upsellItem.properties._upsell_threshold) || 0;
            
            if (!requiredHandle || threshold === 0) {
              // If we don't have the required info, remove the item to be safe
              itemsToRemove.push(upsellItem.key);
              continue;
            }
            
            // Get product IDs from the required collection
            let requiredProductIds = [];
            
            if (collectionsDataScript) {
              try {
                const collectionsData = JSON.parse(collectionsDataScript.textContent);
                if (collectionsData[requiredHandle] && Array.isArray(collectionsData[requiredHandle])) {
                  requiredProductIds = collectionsData[requiredHandle].map(id => String(id));
                }
              } catch (error) {
                console.error('Error parsing collections data:', error);
              }
            }
            
            // Count total quantity of items from required collection still in cart
            let totalMatchingQuantity = 0;
            cartProductIds.forEach(productId => {
              if (requiredProductIds.includes(productId)) {
                totalMatchingQuantity += cartProductQuantities[productId];
              }
            });
            
            // If threshold is no longer met, remove the upsell item
            if (totalMatchingQuantity < threshold) {
              itemsToRemove.push(upsellItem.key);
            }
          }
          
          // Remove all upsell items that no longer meet the threshold
          if (itemsToRemove.length > 0) {
            const updates = {};
            itemsToRemove.forEach(key => {
              updates[key] = 0;
            });
            
            try {
              await fetch(`${window.Shopify.routes.root}cart/update.js`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              });
              
              await this.updateCartState();
            } catch (error) {
              console.error('Error removing dependent upsell items:', error);
            }
          }
        }
      },
      mounted() {
          this.updateCartState();
          this.initCartDrawer();
          
          document.addEventListener('liquid-ajax-cart:request-end', event => {
            const {requestState} = event.detail;
          
            if (requestState.requestType === 'add' && requestState.responseData && requestState.responseData.ok) {
              this.updateCartState();
              this.openCartDrawer();
            }
          });

          this.mounted=true;
          console.log('mounted');

          this.updateGreetingCardInCart();

          // const swiper = new Swiper('.swiper-carousel', {
          //     slidesPerView: 1,
          //     navigation: {
          //         nextEl: `.next-button`,
          //         prevEl: `.prev-button`
          //     },
          //     centeredSlides: false,
          //     spaceBetween: 10,
          //     loop: false,
          //     infinite: false,
          //     breakpoints: {
          //         750: {
          //             slidesPerView: 3
          //         }
          //     },
          //     pagination: {
          //       el: '.swiper-pagination',
          //       type: 'bullets',
          //       clickable: true
          //     }
          //   })
      },
      watch: {
        cartState: {
          handler() {
            this.updateGreetingCardInCart();
          },
          deep: true
        }
      }
    }).mount('#app');
  };

  document.addEventListener("DOMContentLoaded", () => {
      const pageTemplate = document.body.getAttribute('data-page-template');
      if(pageTemplate && pageTemplate.includes('bundle-builder')) {
          Bundle();
      } else if(document.body.classList.contains('template-cart')) {
          Cart();
      } else {
          CartDrawer();
      }
  });

})();
